import React from 'react';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import styles from './styles.module.scss';
function CircularProgress({ display: active }) {
    return (React.createElement(MuiCircularProgress, { color: "secondary", className: styles.indicator, style: { visibility: active ? 'visible' : 'hidden' } }));
}
export default CircularProgress;
